import { render, staticRenderFns } from "./storyBox.vue?vue&type=template&id=93c5fe26&scoped=true&"
import script from "./storyBox.vue?vue&type=script&lang=js&"
export * from "./storyBox.vue?vue&type=script&lang=js&"
import style0 from "./storyBox.vue?vue&type=style&index=0&id=93c5fe26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c5fe26",
  null
  
)

export default component.exports